module.exports = __webpack_public_path__ + "static/img/1.de684a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mentmo/1/1.png
// module id = PkJn
// module chunks = 0